import { useCallback } from "react"
import { ChaingeChain, ChaingeContracts, ChaingeToken, ChaingeTokenChain } from "types/baseType"
import { useAppDispatch, useAppSelector } from "./redux/hooks"
import { setFromChain, setFromToken, setToChain, setToToken } from "./redux/slices/coreInfoSlice"

const useFormatToken = () => {
    const { chains } = useAppSelector((state) => state.app)
    const dispatch = useAppDispatch()

    const  formatToken = useCallback((tokenDetail: ChaingeTokenChain, chainDetail: ChaingeChain, direction: string, otherChains?: ChaingeChain[]) => {
        if(!(otherChains && otherChains.length)) {
            otherChains = chains
        }
        const contracts = tokenDetail.contracts
        let contractInfo: ChaingeContracts | null = null
        if(chainDetail) {
            contractInfo = contracts[chainDetail?.nickName]
        }
        if(!contractInfo) {
            const allChainKeys = Object.keys(contracts) as string[]
            const chainKeys: string[] = []
            allChainKeys.forEach((chainName: string) => {
                const tempChain = chains.find(item => item.nickName === chainName)
                if(tempChain) {
                    chainKeys.push(chainName)
                }
            })
            if(!chainKeys.length) return

            const firstChainName = chainKeys[0]
            contractInfo = contracts[firstChainName]
            const tempChain = (otherChains as ChaingeChain[]).find(item => item.nickName === firstChainName)
            if(tempChain) {
                if(direction === 'from') {
                    dispatch(setFromChain(tempChain))
                } else {
                    dispatch(setToChain(tempChain))
                }
            }
        }
    
        const formatToken: ChaingeToken = {
            index: tokenDetail.index,
            symbol: tokenDetail.symbol,
            name: tokenDetail.name,
            decimals: contractInfo.decimals,
            contractAddress: contractInfo.address,
            disableBridge: tokenDetail?.disableBridge || false,
            imgUrl: tokenDetail.imgUrl || ''
        }
        if(direction === 'from') {
            dispatch(setFromToken(formatToken))
        } else {
            dispatch(setToToken(formatToken))
        }
    }, [chains, dispatch])

    return {formatToken}
}

export default useFormatToken